import stPpsrButton from './ppsrButton.component';

export default angular
  .module('st.Integrations.Ppsr', ['st.Core'])
  .component('stPpsrButton', stPpsrButton)
  .service('ppsrService', (dataService, PPSR, $http) => ({
    search: (params) =>
      dataService.apiRequest(
        null,
        null,
        true,
        null,
        $http.post,
        PPSR.API.SEARCH,
        {
          params
        },
        ['idTicket', 'idAssetToBeFinanced', 'serialNumber', 'serialNumberType'],
        true
      )
  }))
  .constant('PPSR', {
    API: {
      SEARCH: '/api/v1/integrations/ppsr/search'
    },
    SERIAL_NUMBER_TYPES: [
      { id: 1, value: 'Unknown Motor Vehicle Identifier' },
      { id: 2, value: 'VIN' },
      { id: 3, value: 'ChassisNumber' },
      { id: 4, value: 'MV Manufacturers Number' },
      { id: 5, value: 'HIN' },
      { id: 6, value: 'Official Number' },
      { id: 7, value: 'Aircraft Manuf Number' },
      { id: 8, value: 'Airframe Manuf Number' },
      { id: 9, value: 'Helicopter Manuf Number' },
      { id: 10, value: 'Aircraft Nationality Code And Reg Mark' },
      { id: 11, value: 'Patent Number' },
      { id: 12, value: 'Trademark Number' },
      { id: 13, value: 'Design Number' },
      { id: 14, value: 'Plant Breeders Right Number' }
    ]
  });
